import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
// import { AnyARecord } from 'dns';

@Injectable()

export class NavigationService {
  constructor(private router: Router) {

  }

  goToDashboard() {
    this.router.navigate(['/dashboard']);
  }
  goToVoucherProducts(id: any) {
    this.router.navigate(['/voucherproducts/' + id]);
  }
  goToApplicationFail() {
    this.router.navigate(['/applicationfail']);

  }
  goToPayment() {
    this.router.navigate(['/payments']);

  }
  goToPayments(appId) {
    this.router.navigate(['/payments/' + appId]);

  }
  goToVoucher() {
    this.router.navigate(['/voucher']);
  }
  goToGrid() {
    this.router.navigate(['/salesreptable']);
  }
  goToResellerGrid() {
    this.router.navigate(['/resaletable']);

  }
  goToSalesRepForm(id: number, actionInfo: number) {
    this.router.navigate(['/salesreppopup/' + id, actionInfo]);
  }
  goToResaleForm(id: number, actionInfo: number) {
    // debugger
    this.router.navigate(['/resalepage/' + id, actionInfo]);
  }

  goToLogin() {
    this.router.navigate(['/login']);
  }

  goToRegister(isReseller: boolean) {
    this.router.navigate(['/register'], { queryParams: { Id: isReseller ? 1 : 0 } });
  }

  goToCoverage() {
    this.router.navigate(['/homecoverage']);
  }

  goToUnAuthorized() {
    this.router.navigate(['/unauthorized']);
  }

  goToSessionTimedOut() {
    this.router.navigate(['/sessiontimedout']);
  }

  isOnLoginScreen(): boolean {
    return this.router.url === '/login';
  }

  goToPaymentRedirect() {
    this.router.navigate(['/paymentredirect']);
  }

  goToApplicationForm() {
    this.router.navigate(['/applicationform']);
  }

  goToProduct() {
    this.router.navigate(['/product']);
  }

  goToHomeCoverage() {
    this.router.navigate(['/homecoverage']);
  }

  goToRenewVoucher() {
    this.router.navigate(['/renewvoucher']);
  }
  goReTryPaymentVoucher() {
    this.router.navigate(['/retrypayment']);
  }
  goVoucherList(id) {
    this.router.navigate(['/voucherproducts' + id]);
  }
  goVoucherDetails(id) {
    this.router.navigate(['/vouchersdetail/' + id]);
  }
  goVouchernameList() {
    this.router.navigate(['/voucherproducts']);
  }

  goVList() {
    this.router.navigate(['/voucher']);
  }
  goToPayout() {
    this.router.navigate(['/managepayouts']);
  }
  goToManagePayout(id: number) {
    this.router.navigate(['/managepayout/' + id]);
  }

  goToVumatelApplicationHistory(id: number) {
    this.router.navigate(['/vumatelapplicationhistory/' + id]);
  }

  goToResellerDashboard() {
    this.router.navigate(['/reseller-dashboard']);
  }
  goToResellerApplicationManagement() {
    this.router.navigate(['/reseller-application-management'])
  }

  goToSingleApplicationPayment() {
    this.router.navigate(['/singleapplicationpayment']);
  }

  goToEftPaymentAccountInformation() {
    this.router.navigate(['/eftpaymentaccountinformation']);
  }
  goToManageOrder() {
    this.router.navigate(['/manageorder']);
  }
  gotoBenefits() {
    this.router.navigate(['/voucher']);
  }
  addsupport() {
    this.router.navigate(['/add-support'])
  }
  support() {
    this.router.navigate(['/support-ticket'])
  }
  manageUser() {
    this.router.navigate(['/manageuser'])
  }
  addOrUpdateAdminLogin(data: any, isAdd: boolean) {
    this.router.navigate(['/add-login'], {
      queryParams: { ...data, isAdd }
    });
  }
  goToLoginauth() {
    this.router.navigate(['/auth/loginauth'])
  }
}
